import React,{useState} from 'react'
import { Avatar,Button,Paper,Grid,Typography,Container } from '@material-ui/core'
import useStyles from './style'
import LockOutLinedIcon from '@material-ui/icons/LockOpenOutlined'
import Input from './Input'
import { useNavigate } from 'react-router-dom';
import {useDispatch} from 'react-redux'
import {signin,signup} from '../../actions/auth';
import FileBase from 'react-file-base64'
const intialState={firstName:'',lastName:'',email:'',password:'',confirmPassword:''}

export const Auth = () => {
  const [showPassword,setShowpassword]=useState(false);
  const [issignup,setIssignup]=useState(false);
  const [formData,setFormData]=useState(intialState)
  const navigate = useNavigate();
  const classes=useStyles();
  const dispatch =useDispatch();
  


  const switchMode=()=>{
    setIssignup((prevIssignup)=>!prevIssignup)
    setShowpassword(false)
  }

  const handleSubmit=(e)=>{
    e.preventDefault();
    if(issignup){
        dispatch(signup(formData,navigate))
    }else{
      dispatch(signin(formData,navigate))
    }
  }

  const handleChange=(e)=>{
    setFormData({...formData,[e.target.name]:e.target.value});

  }

  const handleShowPassword=()=>setShowpassword((prevShowPassword) => !prevShowPassword)

  return (
    <Container className={classes.container} component="main" maxWidth="xs">
        <Paper className={classes.paper} elevation={3}>
              <Avatar className={classes.avatar}>
                  <LockOutLinedIcon/>
              </Avatar>
              <Typography variant='h5'>{issignup?'Sign Up':'Sign In'}</Typography>
              <form className={classes.form} onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                      {
                        issignup && (
                          <div>
                              <Input name="firstName" label="First Name" handleChange={handleChange} autoFocus half/>
                              <Input name="LastName" label="Last Name" handleChange={handleChange}  half/>
                          </div>
                        )
                      }
                      <Input name="email" label="Email Address" handleChange={handleChange} type="email" />
                      <Input name="password" label="Password" handleChange={handleChange} type={showPassword ? 'text' :'password' } handleShowPassword={handleShowPassword} />
                      {issignup && <div>
                        <Input name="confirmPassword" label="Repeat Password" handleChange={handleChange} type="password"/>
                        <div className="fileInput">
                            <FileBase type="file" multiple={false} name="profilepic" label="profilepic"
                             onDone={({base64})=>setFormData({...formData,Profilepic:base64})} />
                        </div>
                    </div>
                    }
                    </Grid>

                    <Button type="submit" fullWidth variant='contained' color='primary' className={classes.submit}>
                    {issignup? 'Sign up' : 'Sign in' }
                    </Button>

                    <Grid container justify="flex-end">
                        <Grid item>
                            <Button onClick={switchMode}>
                                {issignup ? 'Already have a account? Sign in ':'Dont have an account? Sign up'}
                            </Button>
                        </Grid>
                    
                    </Grid>
              </form>
        </Paper>
    </Container>
  )
}
